/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Description_Focus_LabelInputs */



/**
* | output |
* | --- |
* | "Include in each scene description" |
*
* @param {Ad_Description_Focus_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_description_focus_label = /** @type {((inputs?: Ad_Description_Focus_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Description_Focus_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure dans chaque description de scène")
	if (locale === "de") return /** @type {LocalizedString} */ ("In jede Szenenbeschreibung aufnehmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi in ogni descrizione della scena")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включать в каждое описание сцены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir en cada descripción de escena")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在每条场景描述中包含")
	if (locale === "ja") return /** @type {LocalizedString} */ ("各シーン説明に含める内容")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रत्येक दृश्य विवरण में शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir em cada descrição de cena")
	return /** @type {LocalizedString} */ ("Include in each scene description")
});